import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { color } from '../../templates/Ui';
const StyledMessage = styled.div `
    display: flex;
    padding: 15px;
    font-size: 16px;
    font-weight: 400;
    background-color: #f1f2f2;
    color: #5d5d5d;
    border-radius: 4px;

    + .timeline__message {
        margin-top: 10px;
    }

    ${props => props.type === 'Betalingen' &&
    css `
            border-left: 4px solid ${color.type.payment};
        `};

    ${props => props.type === 'Exploten' &&
    css `
            border-left: 4px solid ${color.type.summons};
        `};

    ${props => props.type === 'Post' &&
    css `
            border-left: 4px solid ${color.type.post};
        `};

    ${props => props.type === 'Aantekeningen' &&
    css `
            border-left: 4px solid ${color.type.annotations};
        `};

    ${props => props.type === 'Processtappen' &&
    css `
            border-left: 4px solid ${color.type.processSteps};
        `};

    ${props => props.type === 'Brieven' &&
    css `
            border-left: 4px solid ${color.type.letters};
        `};
`;
const Message = props => (_jsx(StyledMessage, { className: "timeline__message", ...props }));
export default Message;
